var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"escape-blur",rawName:"v-escape-blur"}],ref:"input",class:[
    _vm.$data.class,
    {
      isNumberType: _vm.isNumberType,
      'font-serif text-white max-md:leading-normal': _vm.isNumberType,
      'w-full leading-tighter': !_vm.isNumberType,
    } ],domProps:{"value":_vm.value},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.defocus($event)},"input":function () { return _vm.debouncedNotify(); },"blur":_vm.notify}})}
var staticRenderFns = []

export { render, staticRenderFns }